import {
  SharedGridPadding,
  SharedGridStyleBaseColor,
} from "features/CenterContent/shared/MainContentGrid";
import { BusGps } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusGps/BusGps";
import OperationalLog from "features/CenterContent/VehicleDetails/shared/OperationalLog";
import { SimpleHeadedContainerSticky } from "features/CenterContent/VehicleDetails/shared/SimpleHeadedContainerSticky";
import { Box, Text } from "shared/components/Spor";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";
import styled, { css } from "styled-components";

const SimpleSharedGridStyleNoPadding = css`
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-radius: 6px;
`;

const BusGpsArea = styled(Box)`
  aspect-ratio: 1/1;
  max-height: 100%;
  min-width: 100%;
  ${SharedGridStyleBaseColor};
  padding: 0;
`;

interface LogAndGpsPanelsProps {
  vehicle: AlternativeTransportVehicle;
  distributionStopPlaces: string;
}

export const LogAndGpsPanels = ({
  vehicle,
  distributionStopPlaces,
}: LogAndGpsPanelsProps) => (
  <>
    <SimpleHeadedContainerSticky
      panelStyle={SimpleSharedGridStyleNoPadding}
      headerHeight="54px"
      variant="main"
      headingLeft={
        <Text variant="xs" fontWeight={600} mr="auto" p={SharedGridPadding}>
          Avgangslogg
        </Text>
      }
    >
      <OperationalLog
        vehicleId={vehicle.id}
        logs={vehicle.logs}
        distributionStopPlaces={distributionStopPlaces}
      />
    </SimpleHeadedContainerSticky>

    <SimpleHeadedContainerSticky
      panelStyle={SimpleSharedGridStyleNoPadding}
      headerHeight="54px"
      variant="main"
      headingLeft={
        <Text variant="xs" fontWeight={600} mr="auto" p={SharedGridPadding}>
          Gps-data
        </Text>
      }
    >
      <BusGpsArea>
        <BusGps vehicle={vehicle} />
      </BusGpsArea>
    </SimpleHeadedContainerSticky>
  </>
);
